import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useHasDashboardAccess } from "@/hooks/useHasDashboardAccess";
import { APP_HOME_ROUTE } from "@/common/routes.common";

/**
 * Lets through only users with merchant dashboard access. Others are sent to the regular app,
 * not signed out — they are still valid merchant users.
 * Must be rendered inside `ProtectedRoute`, which handles signed-out users.
 */
export function DashboardProtectedRoute({ children }: { readonly children: ReactNode }) {
  const hasDashboardAccess = useHasDashboardAccess();

  if (!hasDashboardAccess) {
    return <Navigate to={APP_HOME_ROUTE} replace />;
  }

  return <>{children}</>;
}
